import { useMemo } from "react";
import { arcLabel } from "components/ARC/ARCName";
import { twMerge } from "tailwind-merge";

import { DEFAULT_OSM_CDN_URL_TEMPLATE } from "lib/consts/osmTiles";
import { useOrgFleet } from "providers/OrgFleetProvider";
import OsmMap, { OsmMapLocation } from "components/map/OsmMap";

/** Temporary dashboard GPS data until ARC status exposes live coordinates. */
const HONG_KONG_DUMMY_LOCATIONS: OsmMapLocation[] = [
    {
        id: "demo-arc-1",
        label: "ARC demo 1",
        latitude: 22.3365,
        longitude: 114.1979,
    },
    {
        id: "demo-arc-2",
        label: "ARC demo 2",
        latitude: 22.3193,
        longitude: 114.1694,
    },
    {
        id: "demo-arc-3",
        label: "ARC demo 3",
        latitude: 22.2868,
        longitude: 114.2167,
    },
];

const FleetLocationsMap = ({ className = "" }: { className?: string }) => {
    const { arcsInfo } = useOrgFleet();

    const locations = useMemo(() => {
        return arcsInfo.map((arc, index) => {
            const demoLocation =
                HONG_KONG_DUMMY_LOCATIONS[index % HONG_KONG_DUMMY_LOCATIONS.length];
            return {
                ...demoLocation,
                id: arc.serialNumber,
                label: arcLabel(arc),
            };
        });
    }, [arcsInfo]);

    return (
        <section className={twMerge("w-full shrink-0 rounded-r10 bg-black90 p-4", className)}>
            <h3 className="mb-3">ARC locations</h3>
            <div className="relative">
                <OsmMap
                    locations={locations}
                    tileUrl={DEFAULT_OSM_CDN_URL_TEMPLATE}
                    zoom={13}
                    interactive
                    fitToLocations
                    className="h-[20rem] rounded-r5"
                />
                <div className="pointer-events-none absolute bottom-1 left-1 rounded bg-black/60 px-1.5 py-0.5 text-[10px] text-white/80">
                    © OpenStreetMap contributors
                </div>
            </div>
        </section>
    );
};

export default FleetLocationsMap;
